import api from '@/api.js';
const state = {
    items: [
        {
            name: "tools",
            type: "folder",
            isOpen: true,
            children: [
                { name: "kfz-kennzeichen.ts", type: "file", id: "kfz" },
                { name: "kochrezepte.ts", type: "file", id: "recipes" },
                { name: "icons.ts", type: "file", id: "icons" },
                { name: "lotto.ts", type: "file", id: "lotto" },
                { name: "worktime.ts", type: "file", id: "worktime", hidden: true }
            ]
        },
        {
            name: "demos",
            type: "folder",
            isOpen: false,
            children: [
                { name: "rubiks-cube.vue", type: "file", id: "rubik" },
                { name: "pentomino.ts", type: "file", id: "pentomino" },
                { name: "towers-of-hanoi.ts", type: "file", id: "hanoi" },
                { name: "sokoban.ts", type: "file", id: "sokoban" },
                { name: "piano.ts", type: "file", id: "piano" },
                { name: "chess.ts", type: "file", id: "chess" }
            ]
        }
    ]
};
const mutations = {
    set_menu(state, items) {
        state.items = items;
    },
};
const getters = {
    items: state => state.items
};
const actions = {
    async menu({ commit }, data) {
        console.log('MENU:', data);
        const r = await api.navi.menu(data);
        console.log('started', r.data);
        commit('set_menu', r.data);
    },
};
export const Navi = {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
};
